import { SecurityAccessFeaturesEnum } from 'bff';
import { RouteGuard } from 'components/atoms/route-guard/RouteGuard';
import { RouteBoundary } from 'components/organisms/route-boundary/RouteBoundary';
import { FeatureToggleRoute } from 'modules/app/components/atoms/feature-flags/useFeature';
import { NotFound } from 'modules/app/components/pages/not-found/NotFound';
import MyPracticePage from 'modules/my-practice/components/pages/MyPracticePage';
import { RouteObject } from 'react-router-dom';

export const myPracticeRoutes: RouteObject[] = [
  {
    index: true,
    handle: {
      breadcrumb: { text: 'My practice' }
    },
    element: (
      <FeatureToggleRoute
        component={
          <RouteGuard
            component={
              <RouteBoundary>
                <MyPracticePage />
              </RouteBoundary>
            }
            features={[SecurityAccessFeaturesEnum.MyPractice]}
          />
        }
        fallback={<NotFound />}
        feature='showMyPractice'
      />
    )
  }
];
